import { Col, Container, Row } from "react-bootstrap";
import "./footer.css"
import { useState } from "react";
import FooterData from '../../data/json/common_data/FooterData.json';

const Footer: React.FC = () => {

    const [footerInfo, setFooterInfo] = useState(FooterData?.footerData);

    const currentYear = new Date().getFullYear();

    return (
        <>

            <Container fluid className="footer-container"  >
                <Container className="footer-links-container">
                    <Row col={12}>


                        {footerInfo.map((section: any) => (
                            <Col xs={12} md={6} lg={4} className="mt-3" key={section.id}>
                                <div className="footer-heading">
                                    {section.heading}
                                </div>
                                <div className="footer-info-container">
                                    {section.Children.length > 0 ? (
                                        section.Children.map((child: any) => (
                                            <p className="footer-info-text" key={child.id}>
                                                <a href={child.link}>{child.heading}</a>
                                            </p>
                                        ))
                                    ) : (
                                        <p className="footer-info-text">No information available.</p>
                                    )}
                                </div>
                            </Col>
                        ))}


                    </Row>
                </Container>
            </Container>


            <Container fluid className="footer-middle-container"  >
                <Container >
                    <Row col={12} className="d-flex justify-content-between">

                        <Col xs={12} md={12} lg={9} className="mt-3">
                            <div className="footer-middle-text">
                                Contact Us
                            </div>
                            <Row className="">
                                <Col xs={12} md={6} >
                                    {/* <div className="contact-us-container d-flex mb-3">
                                        <div className="contact-us-img">
                                            <img src='/images/footer-phone-call.png' />
                                        </div>
                                        <div className="footer-contact-text">
                                            +91-9870348912
                                        </div>
                                    </div> */}


                                    <div className="contact-us-container d-flex mb-3">
                                        <div className="contact-us-img">
                                            <img src='/images/Icons/footer-email.png' />
                                        </div>
                                        <div className="footer-contact-text">
                                            sales@paramayatech.com
                                        </div>
                                    </div>
                                </Col>
                                <Col xs={12} md={6} >
                                    <div className="contact-us-container d-flex mb-3">
                                        <div className="contact-us-img">
                                            <img src='/images/Icons/footer-building.png' />
                                        </div>
                                        <div className="footer-contact-text">
                                            1st Floor, Maher Apartment, H. No. 556/123, near Hanuman Mandir, Friends Colony, KT Nagar, Nagpur, Maharashtra 440023
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} md={4} lg={3} className="d-flex flex-column align-items-start align-items-md-end mt-3" >
                            <div className="footer-middle-text">
                                Connect With Us
                            </div>
                            <div className="d-flex align-items-end footer-middle-socials-container ">
                                <div className="footer-middle-socials">
                                    <a target="_blank" href="https://www.instagram.com/paramayatechpvtltd"> <img src='/images/Icons/instagram-dark.png' /> </a>
                                </div>
                                <div className="footer-middle-socials">
                                    <a target="_blank" href="https://www.linkedin.com/company/paramaya-technologies-services/"> <img src='/images/Icons/linkedin-dark.png' /> </a>
                                </div>
                                <div className="footer-middle-socials">
                                    <a target="_blank" href="https://x.com/Paramayatech"> <img src='/images/Icons/twitter.png' /> </a>
                                </div>
                                <div className="footer-middle-socials">
                                    <a target="_blank" href="https://www.facebook.com/profile.php?id=61557715882660"> <img src='/images/Icons/facebook.png' /> </a>
                                </div>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </Container>


            <Container fluid className="footer-bottom-container"  >
                <Container >
                    <Row col={12} className="d-flex justify-content-between align-items-center">

                        <Col xs={12} md={12} lg={12} className="d-flex justify-content-center align-items-center">
                            <div className="footer-bottom-text text-center p-2">
                                &copy; Copyright 2022 - {currentYear} <br />  Powered by Paramaya Technology Services Pvt. Ltd.
                            </div>
                        </Col>

                    </Row>
                </Container>
            </Container>




        </>
    );
}

export default Footer;